<template>
  <div id="app">
    <app-header v-if="!this.$store.state.isSideMenuOpen"></app-header>
    <side-menu v-if="this.$store.state.isSideMenuOpen"></side-menu>
    <router-view v-else/>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader'
import SideMenu from './components/SideMenu'

const { detect } = require('detect-browser')
const browser = detect()
if (browser.name === 'ie') {
  alert('죄송합니다. 인터넷 익스플로러 브라우저는 지원하지 않습니다. 크롬 브라우저로 이용해주세요 ! ')
  document.getElementById('app').addClass('hideAll')
}

export default {
  name: 'App',
  components: { AppHeader, SideMenu },
  mounted () {
    this.$store.commit('initializeSuggestions')
  }
}
</script>

<style>
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
#app {
  /* font-family: 'Noto Sans KR', sans-serif !important; */

  font-family: 'NotoSansCJKkr', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3d4953;
  /*margin-top: 60px;*/
}
  body {
    margin: 0px;
  }

  .bold {
    font-weight: bold;
  }

@media (min-width: 767px) {
  .mobile {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .desktop {
    display: none !important;
  }
}

/* v-dialog css */
.v-dialog-container {
  font-size: 18px;
  color: #3d4953;
  font-weight: 400;
  font-family:'Noto Sans', 'Noto Sans KR', sans-serif;
  text-align: center;
}

.v-dialog.v-dialog-sm .v-dialog-container {
  padding: 10px;
}
/* X 버튼 없애기 */
.v-dialog-container .v-dialog-header {
  display: none;
}
.v-dialog-container .v-dialog-footer {
  text-align: center !important;
}
.v-dialog-container .v-dialog-body {
  padding: 30px 10px 10px 10px !important;
}
.v-dialog-container .v-dialog-body .content {
  font-size: 18px;
}
.v-dialog-container .v-dialog-footer .v-dialog-btn {
  background-color: #6f97fa;
  color: #ffffff;
  font-size: 12px;
  width: 140px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 14px;
}

.hideAll {
  display: none;
}

  @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .v--modal-box {
      width: 90% !important;
      margin: 0 auto;
      overflow:visible !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue